module.exports = __webpack_public_path__ + "static/media/resume.22592f8f.pdf";